import { newImport } from '@/utils/index.js'

export default [
  // ESG
  {
    path: '/ESG',
    name: 'ESG',
    component: () => newImport('ESG/index')
  },
]



// WEBPACK FOOTER //
// ./src/routers/module/ESG.js